import { combineReducers } from "redux";
import relatorioComprovantes from "./slices/relatorio.slice";

const reducer = combineReducers({
  relatorioComprovantes,
});

export default reducer;
